module.exports = __webpack_public_path__ + "img/order10.9d8980bb.png";